import React from 'react';
import logo from '../assets/logo.svg';


const styles = {
  page: { maxWidth: '800px', margin: '0 auto', padding: '48px 24px', fontFamily: "'Segoe UI', sans-serif", color: '#111827' },
  title: { fontSize: '32px', fontWeight: '800', color: '#111827', marginBottom: '8px' },
  updated: { fontSize: '13px', color: '#6b7280', marginBottom: '40px' },
  section: { marginBottom: '32px' },
  h2: { fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' },
  p: { fontSize: '14px', color: '#374151', lineHeight: '1.8', marginBottom: '12px' },
  ul: { fontSize: '14px', color: '#374151', lineHeight: '1.8', paddingLeft: '20px', marginBottom: '12px' },
  li: { marginBottom: '6px' },
  divider: { height: '1px', backgroundColor: '#e5e7eb', margin: '32px 0' },
  contact: { backgroundColor: '#f9fafb', borderRadius: '10px', padding: '20px 24px', border: '1px solid #e5e7eb' },
};

export default function TermsOfUse() {
  return (
    <div style={styles.page}>
      <img src={logo} alt="V2VLab" style={{ height: '32px', marginBottom: '32px', display: 'block' }} />
      <div style={styles.title}>TERMS OF USE</div>
      <div style={styles.updated}>Last updated: July 4, 2026</div>

      <div style={styles.section}>
        <div style={styles.h2}>1. ACCEPTANCE OF TERMS</div>
        <p style={styles.p}>By accessing or using V2VLab ("the Platform"), operated by Converstation AI LLC ("we," "us," or "our"), you agree to be bound by these Terms of Use ("Terms"). IF YOU DO NOT AGREE TO THESE TERMS, DO NOT USE THE PLATFORM.</p>
        <p style={styles.p}>These Terms apply to all users of V2VLab, including Standard, Professional, and Enterprise plan subscribers.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>2. DESCRIPTION OF SERVICE</div>
        <p style={styles.p}>V2VLab is a voice-to-voice conversational simulation platform designed for speech science research, clinical education, and professional training. The Platform provides:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>AI-powered conversational simulation (Lab Mode)</li>
          <li style={styles.li}>Practice conversation sessions (Practice Mode)</li>
          <li style={styles.li}>Acoustic perturbation tools for speech research</li>
          <li style={styles.li}>Automated evaluation and analytics</li>
          <li style={styles.li}>Corpus management and export tools</li>
        </ul>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>3. ELIGIBILITY</div>
        <p style={styles.p}>You must be at least 18 years of age to use V2VLab. By using the Platform, you represent and warrant that you are 18 years of age or older and have the legal capacity to enter into these Terms.</p>
        <p style={styles.p}>If you are using V2VLab on behalf of an institution, organization, or employer, you represent that you have authority to bind that entity to these Terms.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>4. ACCOUNT REGISTRATION</div>
        <p style={styles.p}>To access V2VLab, you must create an account. You agree to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Provide accurate, current, and complete information during registration</li>
          <li style={styles.li}>Maintain and promptly update your account information</li>
          <li style={styles.li}>Keep your password secure and confidential</li>
          <li style={styles.li}>Notify us immediately of any unauthorized use of your account</li>
          <li style={styles.li}>Accept responsibility for all activities that occur under your account</li>
        </ul>
        <p style={styles.p}>We reserve the right to suspend or terminate accounts that provide false information or violate these Terms.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>5. SUBSCRIPTION PLANS AND BILLING</div>
        <p style={styles.p}><strong>STANDARD PLAN (FREE):</strong> The Standard plan is provided at no cost subject to daily and monthly usage limits as described on our Pricing page. We reserve the right to modify Standard plan limits at any time with reasonable notice.</p>
        <p style={styles.p}><strong>PROFESSIONAL PLAN:</strong> The Professional plan is billed at $50.00 USD per month (or $500.00 USD per year for annual subscribers). Voice simulation usage is metered via text-to-speech (TTS) characters. The first 50,000 TTS characters per month are included. Additional usage is billed at $0.70 per 1,000 TTS characters. OVERAGE CHARGES ARE AUTOMATICALLY APPLIED TO YOUR PAYMENT METHOD AT THE END OF EACH BILLING PERIOD.</p>
        <p style={styles.p}><strong>ENTERPRISE PLAN:</strong> Enterprise pricing is negotiated on a custom basis. Contact us at info@converstation.ai.</p>
        <p style={styles.p}>ALL FEES ARE NON-REFUNDABLE EXCEPT AS REQUIRED BY APPLICABLE LAW OR AS EXPRESSLY STATED IN THESE TERMS. Subscriptions automatically renew unless cancelled before the renewal date.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>6. ACCEPTABLE USE</div>
        <p style={styles.p}>You agree NOT to use V2VLab to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Generate content that is illegal, harmful, defamatory, or discriminatory</li>
          <li style={styles.li}>Simulate real, identifiable individuals without their consent</li>
          <li style={styles.li}>Attempt to circumvent usage limits, security measures, or access controls</li>
          <li style={styles.li}>Reverse engineer, decompile, or disassemble any part of the Platform</li>
          <li style={styles.li}>Use the Platform for purposes that violate applicable laws or regulations</li>
          <li style={styles.li}>Transmit malware, viruses, or other malicious code</li>
          <li style={styles.li}>Scrape, harvest, or collect user data without authorization</li>
          <li style={styles.li}>Use the Platform in any way that could damage, disable, or impair our services</li>
          <li style={styles.li}>Share account credentials with unauthorized third parties</li>
        </ul>
        <p style={styles.p}>VIOLATION OF ACCEPTABLE USE POLICIES MAY RESULT IN IMMEDIATE ACCOUNT SUSPENSION OR TERMINATION WITHOUT REFUND.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>7. INTELLECTUAL PROPERTY</div>
        <p style={styles.p}>V2VLab, its features, functionality, underlying technology, and all associated intellectual property are owned by Converstation AI LLC and are protected by copyright, trademark, patent, and other applicable laws.</p>
        <p style={styles.p}><strong>YOUR CONTENT:</strong> You retain ownership of content you create using V2VLab (simulation transcripts, configurations, exported data). By using the Platform, you grant us a limited, non-exclusive license to process and store your content solely to provide the service.</p>
        <p style={styles.p}><strong>OUR CONTENT:</strong> You may not copy, reproduce, distribute, or create derivative works from our platform, interface, or proprietary technology without our express written consent.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>8. RESEARCH AND ACADEMIC USE</div>
        <p style={styles.p}>V2VLab is designed for research and educational purposes. If you use V2VLab outputs in academic publications, presentations, or grants, you agree to:</p>
        <ul style={styles.ul}>
          <li style={styles.li}>Accurately describe V2VLab as an acoustic perturbation and simulation tool</li>
          <li style={styles.li}>Not represent acoustic perturbations as clinically validated disorder simulations unless independently validated</li>
          <li style={styles.li}>Acknowledge that AI-generated content may contain errors and should not be used as sole clinical evidence</li>
          <li style={styles.li}>Comply with your institution's IRB and ethical guidelines when using V2VLab in research involving human participants</li>
        </ul>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>9. THIRD-PARTY SERVICES</div>
        <p style={styles.p}>V2VLab integrates with third-party AI and speech services including Anthropic (Claude), OpenAI (GPT-4o), Google (Gemini), ElevenLabs (text-to-speech), and Deepgram (speech-to-text). Use of these services is subject to their respective terms of service. We are not responsible for the availability, accuracy, or conduct of third-party services.</p>
        <p style={styles.p}>LLM USAGE IS SUBJECT TO THE SELECTED PROVIDER'S OWN USAGE LIMITS AND POLICIES, WHICH ARE OUTSIDE OUR CONTROL.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>10. DISCLAIMER OF WARRANTIES</div>
        <p style={styles.p}>V2VLAB IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.</p>
        <p style={styles.p}>WE DO NOT WARRANT THAT THE PLATFORM WILL BE UNINTERRUPTED, ERROR-FREE, OR COMPLETELY SECURE. ACOUSTIC PERTURBATIONS PROVIDED BY V2VLAB ARE SIGNAL-LEVEL APPROXIMATIONS AND ARE NOT CLINICALLY VALIDATED SIMULATIONS OF SPECIFIC SPEECH OR MOTOR DISORDERS.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>11. LIMITATION OF LIABILITY</div>
        <p style={styles.p}>TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, CONVERSTATION AI LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO LOSS OF PROFITS, DATA, OR GOODWILL, ARISING FROM YOUR USE OF OR INABILITY TO USE V2VLAB.</p>
        <p style={styles.p}>OUR TOTAL LIABILITY TO YOU FOR ALL CLAIMS ARISING FROM OR RELATED TO THESE TERMS OR YOUR USE OF THE PLATFORM SHALL NOT EXCEED THE AMOUNT YOU PAID TO US IN THE THREE (3) MONTHS PRECEDING THE CLAIM.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>12. TERMINATION</div>
        <p style={styles.p}>We reserve the right to suspend or terminate your account and access to V2VLab at our discretion, with or without notice, for violation of these Terms or for any other reason.</p>
        <p style={styles.p}>You may terminate your account at any time by contacting us at info@converstation.ai. Upon termination, your right to use the Platform ceases immediately. We may retain your data as required by law or legitimate business purposes.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>13. GOVERNING LAW</div>
        <p style={styles.p}>These Terms shall be governed by and construed in accordance with the laws of the State of Florida, United States, without regard to its conflict of law provisions. Any disputes arising from these Terms shall be resolved in the courts of Hillsborough County, Florida.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.section}>
        <div style={styles.h2}>14. CHANGES TO TERMS</div>
        <p style={styles.p}>We reserve the right to modify these Terms at any time. We will notify users of material changes via email or a prominent notice on the Platform. YOUR CONTINUED USE OF V2VLAB AFTER CHANGES TAKE EFFECT CONSTITUTES YOUR ACCEPTANCE OF THE REVISED TERMS.</p>
      </div>

      <div style={styles.divider} />

      <div style={styles.contact}>
        <div style={styles.h2}>CONTACT US</div>
        <p style={styles.p}>For questions about these Terms of Use, contact us at:</p>
        <p style={styles.p}><strong>Converstation AI LLC</strong><br />
        Email: <a href="mailto:info@converstation.ai" style={{ color: '#0052CC' }}>info@converstation.ai</a><br />
        Website: <a href="https://converstation.ai" target="_blank" rel="noopener noreferrer" style={{ color: '#0052CC' }}>converstation.ai</a></p>
      </div>
    </div>
  );
}
